/* La lecture des vidéos du journal, au clic et pas avant.

   Quatre articles intègrent une vidéo du domaine. Une iframe YouTube écrit dans
   le terminal du visiteur dès son chargement: l'article 82 de la loi
   Informatique et Libertés s'applique alors, et le consentement préalable
   devient exigible. Sans ce sas, quatre articles suffiraient à imposer une
   bannière de consentement à toute la boutique.

   Ce que le visiteur voit avant de cliquer est une image que nous hébergeons,
   pas la vignette servie par i.ytimg.com, qui est un domaine de Google: la
   prendre là-bas aurait appelé Google au chargement de la page, c'est-à-dire
   exactement ce que la façade prétend éviter.

   Au clic, l'iframe remplace la façade et démarre. `youtube-nocookie.com` plutôt
   que `youtube.com`: à ce stade le visiteur a demandé la vidéo, mais rien
   n'oblige à lui servir en plus la régie publicitaire.
*/
(() => {
  document.querySelectorAll('[data-video-youtube]').forEach((bloc) => {
    const bouton = bloc.querySelector('.fdo-video__lecture');
    const identifiant = bloc.dataset.videoId;
    if (!bouton || !identifiant) return;

    bouton.addEventListener('click', () => {
      const cadre = document.createElement('iframe');
      cadre.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(identifiant)}`
        + '?autoplay=1&rel=0';
      cadre.title = bloc.querySelector('.fdo-video__titre')?.textContent?.trim() || 'Vidéo du domaine';
      cadre.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
      cadre.allowFullscreen = true;
      cadre.loading = 'eager';
      bloc.replaceChildren(cadre);
      bloc.classList.add('fdo-video--lancee');
      // Le focus suit la vidéo: au clavier, il resterait sinon sur un bouton
      // qui n'existe plus, et le lecteur perdrait sa place dans la page.
      cadre.focus();
    });
  });
})();
